'use client';

import { Fragment, RefObject, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { IComponent } from '@lamesarv-sdk/types';
import { IDynamicsOptionSet } from '@/types/dynamicsForms';
import { CustomComponentType, IComponentGenericInquiryForm } from '@/types/cms';
import { GenericInquiryForm } from '@/components/GenericInquiryForm';

interface IGenericHtmlComponentsProps {
  containerRef: RefObject<HTMLDivElement>;
  components: IComponent[];
  locationsOptionSet?: IDynamicsOptionSet;
}

export const GenericHtmlComponents = ({
  containerRef,
  components,
  locationsOptionSet,
}: IGenericHtmlComponentsProps) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) return null;

  return (
    <Fragment>
      {components?.map((component, index) => {
        const element = containerRef.current?.querySelector(`[data-embed="${component.componentType}"]`);
        if (!element) return null;

        if ((component.componentType as string) === CustomComponentType.genericInquiryForm) {
          return createPortal(
            <GenericInquiryForm
              {...(component as unknown as IComponentGenericInquiryForm)}
              locationsOptionSet={locationsOptionSet}
            />,
            element,
            `embed-${component.componentType}-${index}`,
          );
        }

        return null;
      })}
    </Fragment>
  );
};
